import { Tab, TabList, Tabs } from '@chakra-ui/react'
import { ReactElement } from 'react'

interface CustomTabsStringProps {
  solidDeselected?: boolean
  name: string
  value: string
  onChange: (v: string) => void
  choices: string[] | ReactElement[]
  results: string[]
}

const CustomTabsString = ({ name, value, onChange, choices, results, solidDeselected }: CustomTabsStringProps) => {
  const selectedIndex = results.indexOf(value)

  return (
    <Tabs variant="soft-rounded" index={selectedIndex !== -1 ? selectedIndex : 0} size="sm">
      <TabList flexWrap="wrap" gap="6px">
        {choices.map((v: string | ReactElement, i: number) => {
          return (
            <Tab
              key={`${name}-${i}`}
              border={solidDeselected ? 'none' : '1px solid #DCE2EA'}
              fontWeight="400"
              bg={solidDeselected ? '#F5F7F9' : 'transparent'}
              h="32px"
              color="#171C22"
              _hover={{ bg: '#F5F7F9' }}
              _active={{ bg: '#d8d9dd' }}
              _selected={{
                bg: '#171C22',
                border: '1px solid #171C22',
                color: 'white',
              }}
              onClick={() => {
                if (results[i] === value) {
                  onChange('')
                } else {
                  onChange(results[i])
                }
              }}
            >
              {v}
            </Tab>
          )
        })}
      </TabList>
    </Tabs>
  )
}

export default CustomTabsString
